<common-confirm></common-confirm>
<mat-card>
    <div class="subheader">
        <h3 matSubheader>Trusted Devices</h3>
        <button mat-raised-button color="warn" aria-label="Revoke all"
                [disabled]="!dataSource || !dataSource.length" (click)="revokeAll()">
            Revoke all
        </button>
    </div>

    <p>
        Trusted devices skip the two-factor code at login. Revoke any device you no longer
        recognise or use; it will be asked for a 2FA code again on its next login.
    </p>

    <table class="trusted-devices-table mat-elevation-z3">
        <thead>
            <tr>
                <th></th>
                <th class="grow">Label</th>
                <th>Last used</th>
                <th>Expires at</th>
                <th></th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let element of dataSource">
                <td>
                    <span class="chip success" *ngIf="element.is_current">This device</span>
                </td>
                <td class="grow">{{element.device_label || 'Unknown device'}}</td>
                <td>{{element.last_used_at || '-'}}</td>
                <td>{{element.expires_at || '-'}}</td>
                <td class="text-right">
                    <button mat-mini-fab color="warn" aria-label="Revoke" (click)="revokeDevice(element)">
                        <mat-icon>block</mat-icon>
                    </button>
                </td>
            </tr>
            <tr *ngIf="loading">
                <td [attr.colspan]="displayedColumns.length">Loading, please wait...</td>
            </tr>
            <tr *ngIf="!loading && (dataSource === undefined || dataSource.length === 0)">
                <td [attr.colspan]="displayedColumns.length">No trusted devices.</td>
            </tr>
        </tbody>
    </table>
</mat-card>